package org.example.zone360.components


import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.foundation.layout.*
import com.varabyte.kobweb.compose.ui.*
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaBan
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.window
import kotlinx.datetime.*
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.style.LoginInputStyleDefault
import org.example.zone360.style.LoginInputStyleFocus
import org.example.zone360.theme.toSitePalette
import org.example.zone360.utils.Constants
import org.example.zone360.utils.Constants.FONT_FAMILY
import org.example.zone360.utils.Strings
import org.example.zone360.utils.formatInvoiceDate
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*
import org.w3c.dom.HTMLSelectElement
import org.w3c.dom.events.KeyboardEvent
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.percent
import org.w3c.dom.HTMLInputElement


@Composable
fun CustomDatePicker(
    value: String = "",
    placeHolder: String = Strings.YYYY_MM_DD,
    id: String = "",
    width: CSSLengthOrPercentageNumericValue = 300.px,
    height: CSSLengthOrPercentageNumericValue = 45.px,
    fontSize: CSSLengthNumericValue = 13.px,
    marginBottom: CSSLengthNumericValue = 0.px,
    marginLeft: CSSLengthNumericValue = 0.px,
    marginRight: CSSLengthNumericValue = 0.px,
    disabled: Boolean = false,
    disableButKeepStyle: Boolean = false,
    placeHolderAlignRight: Boolean = false,
    onValueChange: (String) -> Unit = {},
    notSelected: (String) -> Boolean = { false }
) {
    // === Helpers ===
    fun today(): LocalDate =
        Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).date

    fun LocalDate.toYyyyMmDdString(): String =
        "${year}${monthNumber.toString().padStart(2, '0')}${dayOfMonth.toString().padStart(2, '0')}"


    fun daysInMonth(year: Int, month: Int): Int =
        when (month) {
            1, 3, 5, 7, 8, 10, 12 -> 31
            4, 6, 9, 11 -> 30
            2 -> if ((year % 4 == 0 && year % 100 != 0) || (year % 400 == 0)) 29 else 28
            else -> 30
        }

    // === State ===
    val initialDate: LocalDate? = remember(value) {
        try {
            when {
                value.contains("-") -> LocalDate.parse(value)
                value.length == 8 -> {
                    val y = value.substring(0, 4).toInt()
                    val m = value.substring(4, 6).toInt()
                    val d = value.substring(6, 8).toInt()
                    LocalDate(y, m, d)
                }
                else -> null
            }
        } catch (_: Exception) { null }
    }

    var selectedDate by remember(value) { mutableStateOf(initialDate) }
    val breakpoint = rememberBreakpoint()
    var year by remember { mutableStateOf(initialDate?.year ?: today().year) }
    var month by remember { mutableStateOf(initialDate?.monthNumber ?: today().monthNumber) }
    var isOpen by remember { mutableStateOf(false) }
    var modifier by remember { mutableStateOf(LoginInputStyleDefault) }

    val sitePalette = ColorMode.current.toSitePalette()

    val now = today()
    val firstDayOfWeek = LocalDate(year, month, 1).dayOfWeek.isoDayNumber % 7
    val totalDays = daysInMonth(year, month)

    modifier = when {
        disabled && !disableButKeepStyle -> Modifier.border(width = 0.px)
        modifier == LoginInputStyleFocus -> LoginInputStyleFocus
        else -> LoginInputStyleDefault
    }

    // === Close when clicking outside ===
    DisposableEffect(isOpen) {
        if (!isOpen) {
            onDispose { }
        } else {
            val listener: (org.w3c.dom.events.Event) -> Unit = { e ->
                val element = e.target
                if (element is org.w3c.dom.Element) {
                    val picker = document.querySelector(".calendar")
                    val input = if (id.isNotBlank()) document.getElementById(id) else null

                    val clickedInside =
                        (picker?.contains(element) == true) || (input?.contains(element) == true)

                    if (!clickedInside) {
                        isOpen = false
                    }
                }
            }

            window.addEventListener("click", listener)

            onDispose {
                window.removeEventListener("click", listener)
            }
        }
    }


    // === Input + Calendar ===
    Box(Modifier.position(Position.Relative).width(width)) {

        // === Input Field ===
        Input(
            type = InputType.Text,
            attrs = modifier
                .id(id)
                .width(width)
                .height(height)
                .margin(bottom = marginBottom, right = marginRight, left = marginLeft)
                .padding(leftRight = 15.px)
                .backgroundColor(
                    if (disabled && !disableButKeepStyle)
                        sitePalette.textFieldBorderColorDisabled.rgb
                    else sitePalette.modalBackgroundColor.rgb
                )
                .color(
                    if (disabled && !disableButKeepStyle)
                        sitePalette.textFieldSupportiveTextColor.rgb
                    else sitePalette.textFieldTextColor.rgb
                )
                .fontSize(fontSize)
                .borderRadius(5.px)
                .outline(width = 0.px, style = LineStyle.None, color = Colors.Transparent)
                .textAlign(if (placeHolderAlignRight) TextAlign.End else TextAlign.Start)
                .onFocusIn {
                    if (disabled) return@onFocusIn
                    modifier = LoginInputStyleFocus }
                .onFocusOut { modifier = LoginInputStyleDefault }
                .cursor(Cursor.Pointer)
                .onClick {
                    if (disabled) return@onClick
                    if (selectedDate == null) {
                        val t = today()
                        year = t.year
                        month = t.monthNumber
                    } else {
                        year = selectedDate!!.year
                        month = selectedDate!!.monthNumber
                    }
                    isOpen = !isOpen
                }
                .onKeyDown { e ->
                    val ev = e.nativeEvent as KeyboardEvent
                    if (ev.key == "Backspace" || ev.key == "Delete") {
                        selectedDate = null
                        onValueChange("")
                    } else ev.preventDefault()
                }
                .styleModifier { property("font-family", FONT_FAMILY) }
                .toAttrs {
                    attr("readonly", "readonly")
                    attr("placeholder", placeHolder)
                    value(formatInvoiceDate(selectedDate?.toYyyyMmDdString() ?: ""))
                }
        )

        // === Calendar Popup ===
        if (isOpen) {
            Div(
                attrs = Modifier
                    .classNames("calendar")
                    .position(Position.Absolute)
                    .top(100.percent)
                    .margin(top = 3.px)
                    .background(sitePalette.modalBackgroundColor.rgb)
                    .border(1.px, LineStyle.Solid, sitePalette.textFieldBorderColor.rgb)
                    .borderRadius(8.px)
                    .padding(12.px)
                    .minWidth(266.px)
                    .width(width)
                    .zIndex(99)
                    .toAttrs()
            ) {

                // === Header: Month + Year ===
                Row(
                    Modifier.fillMaxWidth()
                        .justifyContent(JustifyContent.SpaceBetween)
                        .alignItems(AlignItems.Center)
                        .margin(bottom = 8.px)
                ) {
                    Button(
                        attrs = Modifier
                            .fontSize(18.px)
                            .background(Colors.Transparent)
                            .border(width = 0.px)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                month--
                                if (month < 1) { month = 12; year-- }
                            }
                            .toAttrs()
                    ) { FaChevronLeft(
                        size = IconSize.SM)}

                    Row(Modifier.alignItems(AlignItems.Center).gap(8.px)) {
                        // Month select
                        Select(
                            attrs = Modifier
                                .fontSize(14.px)
                                .cursor(Cursor.Pointer)
                                .background(Colors.Transparent)
                                .border(width = 0.px)
                                .outline(width = 0.px, style = LineStyle.None, color = Colors.Transparent)
                                .toAttrs {
                                    onChange { ev ->
                                        val newMonth = (ev.target as HTMLSelectElement).value.toInt()
                                        month = newMonth
                                    }
                                }
                        ) {
                            Month.entries.forEachIndexed { i, m ->
                                Option(
                                    value = (i + 1).toString(),
                                    attrs = { if ((i + 1) == month) attr("selected", "") }
                                ) { FieldTitleTextNormalSimple(m.name.lowercase().replaceFirstChar { it.uppercase() }) }
                            }
                        }

                        // Replace your year Input component with this:

                        Input(
                            type = InputType.Number,
                            attrs = Modifier
                                .width(70.px)
                                .fontSize(14.px)
                                .textAlign(TextAlign.Center)
                                .background(Colors.Transparent)
                                .border(width = 0.px)
                                .fontFamily(FONT_FAMILY)
                                .outline(width = 0.px, style = LineStyle.None, color = Colors.Transparent)
                                .styleModifier {

                                    property("caret-color", "transparent")
                                    property("cursor", "default")
                                }
                                .onKeyDown { ev ->
                                    val el = ev.target as? HTMLInputElement
                                    val key = ev.key

                                    if (key == "Enter") {
                                        el?.blur()
                                        ev.preventDefault()
                                        return@onKeyDown
                                    }
                                    val inputElement = ev.target as HTMLInputElement
                                    inputElement.style.setProperty("caret-color", "auto")
                                }
                                .onFocusOut { ev ->
                                    val inputElement = ev.target as HTMLInputElement
                                    inputElement.style.setProperty("caret-color", "transparent")

                                    val enteredYear = inputElement.value.toIntOrNull() ?: year

                                    year = when {
                                        enteredYear < 1900 -> 1901
                                        enteredYear > 2100 -> today().year
                                        else -> enteredYear
                                    }

                                    inputElement.value = year.toString()
                                }
                                .toAttrs {

                                    attr("min", "1900")
                                    attr("max", "2100")
                                    onChange { ev ->
                                        val newYear = (ev.target as HTMLInputElement).value.toIntOrNull()
                                        if (newYear != null && newYear in 1900..2100) {
                                            year = newYear
                                        }
                                    }
                                }
                        )
                    }
                    LaunchedEffect(year) {
                        val el = document.querySelector("input[type='number']") as? HTMLInputElement
                        el?.value = year.toString()
                    }

                    Button(
                        attrs = Modifier
                            .fontSize(18.px)
                            .background(Colors.Transparent)
                            .border(width = 0.px)
                            .cursor(Cursor.Pointer)
                            .onClick {
                                month++
                                if (month > 12) { month = 1; year++ }
                            }
                            .toAttrs()
                    ) { FaChevronRight(
                        size = IconSize.SM) }
                }

                // === Weekdays Header ===
                Row(Modifier.fillMaxWidth().margin(bottom = 4.px)) {
                    Strings.WEEK_DAYS_LIST.forEach { day ->
                        Box(
                            Modifier
                                .flex(1)
                                .textAlign(TextAlign.Center)
                                .height(30.px) // Match the day boxes height
                                .lineHeight(30.px) // Center text vertically
                        ) {
                            FieldTitleTextNormalSimple(day)
                        }
                    }
                }
                // === Days Grid ===
                Div(
                    attrs = Modifier
                        .display(DisplayStyle.Grid)
                        .gridTemplateColumns { repeat(7) { size(1.fr) } }
                        .gap(5.px)
                        .toAttrs()
                ) {
                    repeat(firstDayOfWeek) { Div { } }
                    for (d in 1..totalDays) {
                        val thisDate = LocalDate(year, month, d)
                        val isPast = thisDate < now

                        key(thisDate) {
                            var isHovered by remember { mutableStateOf(false) }

                            val isSelected = selectedDate == thisDate
                            val isToday = thisDate == now

                            Box(
                                modifier = Modifier
                                    .borderRadius(100.px)
                                    .cursor(if (isPast) Cursor.NotAllowed else Cursor.Pointer)
                                    .size(30.px)
                                    .onMouseEnter { if (isPast) isHovered = true }
                                    .onMouseLeave { isHovered = false }
                                    .thenIf(isSelected) {
                                        Modifier.background(sitePalette.primary.rgb)
                                    }
                                    .thenIf(isHovered && !isSelected && !isPast) {
                                        Modifier.background(sitePalette.textFieldBorderColor.rgb)
                                    }
                                    .thenIf(isToday && !isSelected && !isHovered) {
                                        Modifier.background(sitePalette.textFieldBorderColor.rgb)
                                    }
                                    .onClick {
                                        if (isPast) return@onClick
                                        val newDate = thisDate.toYyyyMmDdString()
                                        if (notSelected(newDate)) {
                                            isOpen = false
                                            return@onClick
                                        }
                                        selectedDate = thisDate
                                        isOpen = false
                                        onValueChange(newDate)
                                    },
                                contentAlignment = Alignment.Center
                            ) {
                                SpanText(
                                    d.toString(),
                                    modifier = Modifier
                                        .fontSize(13.px)
                                        .color(
                                            when {
                                                isPast -> sitePalette.textFieldSupportiveTextColor.rgb.copyf(alpha = 0.5f)
                                                isSelected -> Colors.White
                                                else -> sitePalette.textFieldTextColor.rgb
                                            }
                                        )
                                        .fontFamily(Constants.FONT_FAMILY)
                                        .textAlign(TextAlign.Center)
                                        .width(100.percent)
                                        .lineHeight(30.px) // This ensures vertical centering
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}






